export const SET_ACTIVE_MODAL = 'SET_ACTIVE_MODAL';

export default {};
